import { Stack, StackProps, Typography } from "@mui/material";
import { FC, Fragment } from "react";
import components from "..";

interface SalifyBannerWrapperMarqueeProps {
  animationName?: string;
  animationDuration?: string;
  stackProps?: StackProps;
  components: any[];
}

const SalifyBannerWrapperMarquee: FC<SalifyBannerWrapperMarqueeProps> = (props) => {
  return (
    <Stack spacing={10} direction="row" overflow="hidden" {...props.stackProps}>
      {Array.from({ length: 10 }, (_, index) => (
        <Stack
          key={index}
          spacing={10}
          direction="row"
          flex="0 0 auto"
          alignItems="center"
          width="max-content"
          sx={{
            animationName: props.animationName || "scrollingLeft",
            animationDuration: props.animationDuration || "10s, 30s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationPlayState: "running",
            willChange: "transform, width",
          }}
        >
          {props.components?.length &&
            props.components.map((item, index) => {
              const Component =
                (components as any)?.[item.blockName]?.[item.variant || "default"] ?? null;

              return Component ? (
                <Fragment key={index}>
                  <Component {...item.props} />
                </Fragment>
              ) : (
                <Typography color="red">
                  Chưa hỗ trợ component với block name: {item.blockName}
                </Typography>
              );
            })}
        </Stack>
      ))}
    </Stack>
  );
};

SalifyBannerWrapperMarquee.displayName = "SalifyBannerWrapperMarquee";

export default SalifyBannerWrapperMarquee;
